(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ak-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dataEl = document.getElementById('ak-bb-product-data');
    if (!dataEl) return;
    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; }

    var grid = document.getElementById('ak-bb-grid');
    var loadMoreBtn = document.getElementById('ak-bb-load-more');
    var tabs = document.querySelectorAll('.ak-bb__tab');
    var searchInput = document.getElementById('ak-bb-search');
    var sortSelect = document.getElementById('ak-bb-sort');
    var slotsEl = document.getElementById('ak-bb-slots');
    var minisEl = document.getElementById('ak-bb-minis');
    var countEls = [document.getElementById('ak-bb-count'), document.getElementById('ak-bb-count-2')];
    var checkoutBtn = document.getElementById('ak-bb-checkout');
    var errorEl = document.getElementById('ak-bb-error');

    var PAGE_SIZE = 15;
    var visibleCount = PAGE_SIZE;
    var activeCat = 'all';
    var searchTerm = '';
    var sortMode = 'featured';
    var selected = [null, null, null, null];

    function money(amount) {
      return (amount / 100).toFixed(2).replace('.', ',') + ' zł';
    }

    function filteredProducts() {
      var list = products.slice();
      if (activeCat !== 'all') {
        list = list.filter(function (p) { return p.category === activeCat; });
      }
      if (searchTerm) {
        var t = searchTerm.toLowerCase();
        list = list.filter(function (p) { return p.title.toLowerCase().indexOf(t) !== -1; });
      }
      if (sortMode === 'price-asc') list.sort(function (a, b) { return a.price - b.price; });
      if (sortMode === 'price-desc') list.sort(function (a, b) { return b.price - a.price; });
      if (sortMode === 'title-asc') list.sort(function (a, b) { return a.title.localeCompare(b.title, 'pl'); });
      return list;
    }

    function isSelected(id) {
      return selected.some(function (s) { return s && String(s.id) === String(id); });
    }

    function renderGrid() {
      var list = filteredProducts();
      var slice = list.slice(0, visibleCount);
      // Zapamiętaj, które zdjęcie było oglądane, bo grid renderuje się od nowa po każdym dodaniu
      var galPos = {};
      grid.querySelectorAll('.ak-bb__gal').forEach(function (g) { galPos[g.getAttribute('data-id')] = g.scrollLeft; });
      grid.innerHTML = slice.map(function (p) {
        var added = isSelected(p.id);
        var full = selected.every(function (s) { return s !== null; }) && !added;
        var alt = p.title.replace(/"/g, '&quot;');
        var imgs = p.images && p.images.length ? p.images : [p.image];
        var gallery =
          '<div class="ak-bb__card-media">' +
            '<div class="ak-bb__gal" data-id="' + p.id + '">' +
              imgs.map(function (src, i) {
                return '<img src="' + src + '" alt="' + alt + (i ? ', zdjęcie ' + (i + 1) : '') + '" loading="lazy" width="400" height="400">';
              }).join('') +
            '</div>' +
            (imgs.length > 1
              ? '<button type="button" class="ak-bb__gal-btn ak-bb__gal-btn--prev" data-dir="-1" aria-label="Poprzednie zdjęcie">‹</button>' +
                '<button type="button" class="ak-bb__gal-btn ak-bb__gal-btn--next" data-dir="1" aria-label="Następne zdjęcie">›</button>' +
                '<div class="ak-bb__gal-dots">' + imgs.map(function (_, i) { return '<span' + (i ? '' : ' class="is-on"') + '></span>'; }).join('') + '</div>'
              : '') +
          '</div>';
        return (
          '<div class="ak-bb__card" data-id="' + p.id + '">' +
            gallery +
            '<div class="ak-bb__card-body">' +
              '<p class="ak-bb__card-title">' + p.title + '</p>' +
              '<p class="ak-bb__card-price">' +
                (p.compareAt ? '<s class="ak-bb__card-compare">' + p.compareAt + '</s> ' : '') +
                p.priceFormatted +
              '</p>' +
              (p.lastOne ? '<p class="ak-bb__card-last">Ostatnia sztuka</p>' : '') +
              '<button type="button" class="ak-bb__card-add' + (added ? ' is-added' : '') + '" data-id="' + p.id + '"' + (full ? ' disabled' : '') + '>' +
                (added ? 'Dodano ✓' : 'Dodaj +') +
              '</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
      grid.querySelectorAll('.ak-bb__gal').forEach(function (g) {
        var pos = galPos[g.getAttribute('data-id')];
        if (pos) { g.scrollLeft = pos; updateDots(g); }
      });
      loadMoreBtn.hidden = visibleCount >= list.length;
    }

    function updateDots(gal) {
      var dots = gal.parentNode.querySelectorAll('.ak-bb__gal-dots span');
      if (!dots.length) return;
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }

    function renderSlots() {
      var boxes = slotsEl.querySelectorAll('.ak-bb__slot');
      boxes.forEach(function (box, i) {
        var item = selected[i];
        var body = box.querySelector('.ak-bb__slot-body');
        if (item) {
          box.classList.add('is-filled');
          body.innerHTML = '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="200" height="200"><button type="button" class="ak-bb__slot-remove" data-slot="' + i + '" aria-label="Usuń">×</button>';
        } else {
          box.classList.remove('is-filled');
          body.innerHTML = '<span class="ak-bb__slot-plus">+</span>';
        }
      });
      if (minisEl) {
        minisEl.innerHTML = selected.map(function (item, i) {
          if (!item) {
            return '<div class="ak-bb__mini"><span class="ak-bb__mini-num">' + (i + 1) + '</span></div>';
          }
          return (
            '<div class="ak-bb__mini is-filled">' +
              '<span class="ak-bb__mini-num">' + (i + 1) + '</span>' +
              '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="60" height="60">' +
              '<button type="button" class="ak-bb__mini-x" data-slot="' + i + '" aria-label="Usuń ' + item.title.replace(/"/g, '&quot;') + '">×</button>' +
            '</div>'
          );
        }).join('');
      }

      var count = selected.filter(Boolean).length;
      countEls.forEach(function (el) { if (el) el.textContent = count; });
      checkoutBtn.disabled = count < 4;
    }

    function addProduct(id) {
      if (isSelected(id)) return;
      var emptyIndex = selected.indexOf(null);
      if (emptyIndex === -1) return;
      var product = products.filter(function (p) { return String(p.id) === String(id); })[0];
      if (!product) return;
      selected[emptyIndex] = product;
      renderSlots();
      renderGrid();
    }

    function removeSlot(index) {
      selected[index] = null;
      renderSlots();
      renderGrid();
    }

    // scroll nie bubluje — łapiemy go w fazie capture dla wszystkich galerii naraz
    grid.addEventListener('scroll', function (e) {
      if (e.target.classList && e.target.classList.contains('ak-bb__gal')) updateDots(e.target);
    }, true);

    grid.addEventListener('click', function (e) {
      var nav = e.target.closest('.ak-bb__gal-btn');
      if (nav) {
        var gal = nav.parentNode.querySelector('.ak-bb__gal');
        var n = gal.children.length;
        var cur = Math.round(gal.scrollLeft / gal.clientWidth);
        var next = (cur + parseInt(nav.getAttribute('data-dir'), 10) + n) % n;
        gal.scrollTo({ left: next * gal.clientWidth, behavior: 'smooth' });
        return;
      }
      var btn = e.target.closest('.ak-bb__card-add');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-id');
      if (isSelected(id)) {
        var idx = -1;
        selected.forEach(function (s, i) {
          if (idx === -1 && s && String(s.id) === String(id)) idx = i;
        });
        if (idx !== -1) removeSlot(idx);
      } else {
        addProduct(id);
      }
    });

    slotsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.ak-bb__slot-remove');
      if (!btn) return;
      removeSlot(parseInt(btn.getAttribute('data-slot'), 10));
    });

    if (minisEl) {
      minisEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.ak-bb__mini-x');
        if (!btn) return;
        removeSlot(parseInt(btn.getAttribute('data-slot'), 10));
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        activeCat = tab.getAttribute('data-cat');
        visibleCount = PAGE_SIZE;
        renderGrid();
      });
    });

    searchInput.addEventListener('input', function () {
      searchTerm = searchInput.value.trim();
      visibleCount = PAGE_SIZE;
      renderGrid();
    });

    sortSelect.addEventListener('change', function () {
      sortMode = sortSelect.value;
      renderGrid();
    });

    loadMoreBtn.addEventListener('click', function () {
      visibleCount += PAGE_SIZE;
      renderGrid();
    });

    var checkoutBtnOriginalText = checkoutBtn.textContent;

    checkoutBtn.addEventListener('click', function () {
      if (selected.some(function (s) { return !s; })) return;
      errorEl.hidden = true;
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Dodawanie…';

      var items = selected.map(function (p) {
        return { id: p.variantId, quantity: 1, properties: { _bundle: 'pick4' } };
      });

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
          });
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Nie udało się dodać produktów do koszyka.'); });
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = checkoutBtnOriginalText;
        });
    });

    var noticeEl = document.getElementById('ak-bb-cart-notice');
    if (noticeEl) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (!cart || !cart.item_count) return;
          var n = cart.item_count;
          var word = n === 1 ? 'produkt' : (n < 5 ? 'produkty' : 'produktów');
          noticeEl.textContent =
            'Masz już ' + n + ' ' + word + ' w koszyku. Przejście do kasy z zestawem zastąpi zawartość koszyka wybranymi tu 4 sztukami.';
          noticeEl.hidden = false;
        })
        .catch(function () {});
    }

    renderGrid();
    renderSlots();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-waterproof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var videos = document.querySelectorAll('video[data-ak-lazy-video]');
    if (!videos.length) return;

    function start(video) {
      if (video.dataset.akStarted) return;
      video.dataset.akStarted = '1';
      video.preload = 'auto';
      video.muted = true;
      var play = video.play();
      if (play && typeof play.catch === 'function') play.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          start(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '200px 0px' }
    );

    videos.forEach(function (v) { observer.observe(v); });
  })();

  } catch(e) { console.error(e); }
})();
})();
